document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.ucm__gallery').forEach(function (node) {
        const dotsWrap = node.querySelector('.ucm__dots');
        if (!dotsWrap) return;

        function setActive() {
            const embla = node._embla;
            if (!embla) return;
            const i = embla.selectedScrollSnap();
            dotsWrap.querySelectorAll('.ucm__dot').forEach((el, idx) => {
                el.classList.toggle('is-active', idx === i);
            });
            const active = dotsWrap.querySelector('.ucm__dot.is-active');
            if (active) {
                const left = active.offsetLeft - (dotsWrap.clientWidth - active.offsetWidth) / 2;
                dotsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
            }
        }

        function buildDots() {
            const embla = node._embla;
            dotsWrap.innerHTML = '';
            const count = embla ? embla.scrollSnapList().length : node.querySelectorAll('.embla__slide').length;
            for (let i = 0; i < count; i++) {
                const b = document.createElement('button');
                b.type = 'button';
                b.className = 'ucm__dot';
                b.addEventListener('click', () => embla && embla.scrollTo(i));
                dotsWrap.appendChild(b);
            }
            setActive();
        }

        function waitForEmbla() {
            if (node._embla) {
                node._embla.on('select', setActive);
                node._embla.on('reInit', buildDots);
                buildDots();
            } else {
                if (window.lpEmbla && window.lpEmbla.initEmblaFor) window.lpEmbla.initEmblaFor(node);
                setTimeout(waitForEmbla, 50);
            }
        }
        waitForEmbla();
    });

    document.querySelectorAll('.ucm').forEach((block) => {
        const open = block.querySelector('.js-open-video');
        const modal = block.querySelector('.ucm__overlay');
        const video = block.querySelector('.ucm__media');
        const close = modal ? modal.querySelector('.close') : null;
        const frame = modal ? modal.querySelector('iframe') : null;

        if (!open || !modal || !close || !frame) return;

        open.addEventListener('click', () => {
            const base = open.dataset.video;
            if (!base) return;
            const src = base.includes('?') ? base + '&autoplay=1' : base + '?autoplay=1';
            frame.src = src;
            modal.classList.add('active');
            video.classList.add('active');
            document.body.classList.add('video-open');

            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            block._preventScroll = (e) => e.preventDefault();
            document.addEventListener('touchmove', block._preventScroll, { passive: false, capture: true });
        });

        function closeVideo() {
            frame.src = '';
            modal.classList.remove('active');
            video.classList.remove('active');
            document.body.classList.remove('video-open');

            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
            if (block._preventScroll) {
                document.removeEventListener('touchmove', block._preventScroll, { capture: true });
                block._preventScroll = null;
            }
        }

        close.addEventListener('click', closeVideo);
        modal.addEventListener('click', (e) => { if (e.target === modal) closeVideo(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeVideo(); });
    });
});